<template lang="pug">
div
    canvas(
        ref="canvas"
        class="tl-confetti-canvas"
    )
</template>

<script setup>
import ConfettiCanvas from 'canvas-confetti'
import { ref, onMounted, inject, computed } from 'vue'
import { getInjects } from '@/components/$tl/utils/injects'

const props = defineProps({
    count: [String, Number],
    spred: [String, Number],
    angle: [String, Number],
    startVelocity: [String, Number],
    gravity: [String, Number],
    drift: [String, Number],
    ticks: [String, Number],
    origin: Object,
})

const injects = getInjects(props, inject)

const confetti = ref(null)
const canvas = ref(null)

const count = computed(() => parseInt(props.count, 10) || parseInt(injects.count?.value, 10) || 100)
const spred = computed(() => parseInt(props.spred, 10) || parseInt(injects.spred?.value, 10) || 160)
const angle = computed(() => parseInt(props.angle, 10) || parseInt(injects.angle?.value, 10) || 90)
const startVelocity = computed(() => parseInt(props.startVelocity, 10) || parseInt(injects.startVelocity?.value, 10) || 45)
const gravity = computed(() => parseInt(props.gravity, 10) || parseInt(injects.gravity?.value, 10) || 1)
const drift = computed(() => parseInt(props.drift, 10) || parseInt(injects.drift?.value, 10) || 0)
const ticks = computed(() => parseInt(props.ticks, 10) || parseInt(injects.ticks?.value, 10) || 200)

const origin = computed(
    () => props.origin || injects.origin?.value || { x: 0.5, y: 0.5 },
)

const play = () => {
    confetti.value({
        particleCount: count.value,
        spread: spred.value,
        angle: angle.value,
        startVelocity: startVelocity.value,
        gravity: gravity.value,
        drift: drift.value,
        ticks: ticks.value,
        origin: origin.value,
        disableForReducedMotion: true,
        colors: ['#0051F9', '#003DBD', '#007FFF', '#00BDFF', '#001A47', '#0051F9', '#0051F9'],
    })
}

onMounted(() => {
    confetti.value = ConfettiCanvas.create(canvas.value, {
        resize: true,
    })
})

defineExpose({
    play,
})
</script>

<style lang="sass" scoped>
.tl-confetti-canvas
    width: 100%
    height: 100%
    position: fixed
    top: 0
    left: 0
    pointer-events: none
    z-index: 1000
</style>
